export const aboutProfileIconTokens = [
    'arrowRight',
    'award',
    'badgeCheck',
    'briefcase',
    'building',
    'calendar',
    'camera',
    'checkCircle',
    'dot',
    'externalLink',
    'facebook',
    'globe',
    'hammer',
    'heartHandshake',
    'idCard',
    'instagram',
    'linkedin',
    'mail',
    'mapPin',
    'messageCircle',
    'phone',
    'play',
    'shieldCheck',
    'sparkles',
    'star',
    'trophy',
    'users',
    'wrench',
    'youtube',
] as const;

export type AboutProfileIconToken = (typeof aboutProfileIconTokens)[number];

export const aboutProfileTokens = {
    colors: {
        background: '#f6f7fb',
        surface: '#ffffff',
        surfaceSoft: '#f0f7f6',
        text: '#111827',
        textSoft: '#374151',
        textMuted: '#667085',
        accent: '#0f766e',
        accentDark: '#115e59',
        accentSoft: 'rgba(15, 118, 110, 0.12)',
        accentWash: 'rgba(15, 118, 110, 0.07)',
        accentContrast: '#ffffff',
        action: '#2563eb',
        actionDark: '#1d4ed8',
        actionSoft: 'rgba(37, 99, 235, 0.1)',
        actionContrast: '#ffffff',
        border: 'rgba(17, 24, 39, 0.1)',
        borderStrong: 'rgba(17, 24, 39, 0.16)',
        shadow: '0 24px 70px rgba(17, 24, 39, 0.11)',
        softShadow: '0 14px 36px rgba(17, 24, 39, 0.08)',
        mediaFallback: '#dbe4ea',
        mapBackground: '#eef6f2',
    },
    radius: {
        media: 8,
        panel: 8,
        tile: 8,
        button: 8,
        icon: 999,
        pill: 999,
    },
    spacing: {
        sectionY: 54,
        sectionX: 20,
        heroGap: 34,
        contentGap: 24,
        tileGap: 14,
    },
    sizes: {
        maxWidth: 1180,
        heroMediaMinHeight: 430,
        heroMediaMobileMinHeight: 280,
        icon: 38,
        smallIcon: 30,
    },
    typography: {
        fontFamily:
            'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        eyebrow: {
            fontSize: 13,
            lineHeight: 1.2,
            fontWeight: 850,
            letterSpacing: 0,
            textTransform: 'uppercase' as const,
        },
        title: {
            fontSize: 46,
            tabletFontSize: 40,
            mobileFontSize: 32,
            lineHeight: 1.04,
            fontWeight: 870,
            letterSpacing: 0,
        },
        sectionTitle: {
            fontSize: 25,
            mobileFontSize: 21,
            lineHeight: 1.15,
            fontWeight: 850,
            letterSpacing: 0,
        },
        cardTitle: {
            fontSize: 16,
            lineHeight: 1.25,
            fontWeight: 800,
            letterSpacing: 0,
        },
        body: {
            fontSize: 16,
            mobileFontSize: 15,
            lineHeight: 1.65,
            fontWeight: 500,
            letterSpacing: 0,
        },
    },
} as const;

export type AboutProfileColorToken = keyof typeof aboutProfileTokens.colors;
